<template>
  <div>
    <router-view v-slot="{ Component }">
      <!-- 根据路由的meta.keepAlive属性决定是否缓存，同时保留:key属性 -->
      <template v-if="route.meta.keepAlive">
        <keep-alive :max="2">
          <component :is="Component" :key="$route.fullPath" />
        </keep-alive>
      </template>
      <component v-else :is="Component" :key="$route.fullPath" />
    </router-view>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
const router = useRouter();
const store = useStore();
const route = useRoute();

// 路由切换后处理滚动和状态重置
// router.afterEach((to, from) => {

// });
</script>

<style lang="less" scoped></style>
